import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    applyPrizeBoth,
    togglePrizeBoxWeb
} from './../../../actions/FilterActions';
import OutsideNotifier from '../../../OutsideNotifier';
import common from '../../../common';

class PlayerSortBy extends Component {
    onPriceFilterClick = (e, priceID) => {
        e.stopPropagation();
        this.props.applyPrizeBoth(priceID);
    };
    onTapOutsidePriceBoxOpenForWeb = (e) => {
        e.stopPropagation();
        this.props.togglePrizeBoxWeb();
    };

    render() {
        if (this.props.isPriceBoxOpenForWeb) {
            const desktopPriceClass = common.makeClasses({
                'si-filters-expanded': true,
                'si-web-price-filter': true,
            });
            return <OutsideNotifier handler={ (e) => this.onTapOutsidePriceBoxOpenForWeb(e) }>
                <div className={ desktopPriceClass }>
                    <div className="si-price-filter si-more-filters">
                        <label>{ this.props.trans.filterByPrice }</label>
                        <div className="si-price-expand si-flexBox">
                            { this.props.priceFilter.map(el => {
                                const className = common.makeClasses({
                                    'si-price-range': true,
                                    'si-active': this.props.priceFilterSelected.indexOf(el.id) > -1
                                });
                                return <div className={ className } key={ el.id } onClick={ (e) => {
                                    this.onPriceFilterClick(e, el.id)
                                } }>{ el.label }</div>
                            }) }
                        </div>
                    </div>
                </div>
            </OutsideNotifier>
        } else {
            return null;
        }
    }
}

const mapStateToProps = (state) => {
    return {
        trans: state.appData.trans,
        isPriceBoxOpenForWeb: state.formationData.isPriceBoxOpenForWeb,
        priceFilter: state.formationData.priceFilter,
        priceFilterSelected: state.formationData.playerFilters.priceFilterSelected,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        applyPrizeBoth: (priceID) => dispatch(applyPrizeBoth(priceID)),
        togglePrizeBoxWeb: (bool) => dispatch(togglePrizeBoxWeb()),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(PlayerSortBy);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/PrizePopupWeb.js